import { render, staticRenderFns } from "./TheLayoutView.vue?vue&type=template&id=35bbe9b8&"
import script from "./TheLayoutView.vue?vue&type=script&lang=js&"
export * from "./TheLayoutView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TheLayoutView.vue"
export default component.exports